<template>
  <div ref="target">
    <slot />
  </div>
</template>

<script>
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default {
  mounted() {
    this.animate();
  },
  methods: {
    animate() {
      let mm = gsap.matchMedia();
      const target = this.$refs.target;

      const items = target.querySelectorAll('.article-grid__item');
      const staggeredImages = target.querySelectorAll('.article-grid--staggered img');

      staggeredImages.forEach((image) => {
        gsap.to(
          image,
          {
            scrollTrigger: {
              trigger: image,
              toggleActions: 'restart none none reverse',
              scrub: 1,
            },
            objectPosition: '70% 50%',
          }
        )
      });
    }
  }
}
</script>